<template>
    <div id="signup-container">
      <div class="section-container">

        <div class="section">
          <h2>Sign up for all the latest news</h2>

          <div class="invalid-warning">
            <span v-if="showWarning">{{ message }}</span>
          </div>

          <input id="email-input" type="email" placeholder="Enter your email here" v-model="email"><br />

          <button id="send-button" v-on:click="registerInterest">Send</button>
          <div id="spinner" style="display: none; padding-top: 20px;">
            <div class="lds-dual-ring"></div>
          </div>
          <p>70-72 The Havens, Ipswich, IP3 9BF</p>

          <p>Tel: 01473 927802 &nbsp; | &nbsp; info@spinninghouse.co.uk</p>

          <div class="socail-container">
            <a href="https://www.facebook.com/spinninghouseinvestmentproperty/" target="_blank">
              <img src="../assets/facebook-icon.jpg">
            </a>
            <a href="https://www.instagram.com/tomasz_tcho/" target="_blank">
              <img src="../assets/insta-icon.jpg">
            </a>
            <a href="https://www.youtube.com/channel/UCR2AeQRVSNov5cKVbXGxWew?fbclid=IwAR18vYTGNxFjvbZXZm7FYlZt3fxCCUQ5IfJ728MG47-ypeJmuubBxQ2yKus" target="_blank">
              <img src="../assets/youtube-icon.jpg">
            </a>
          </div>
        </div>

        <div class="section bg-img-section">
          <h2 id="status-text" style="color: #000">Yes, I want to join the webinar,<br /> Sign me up!</h2>
          <button id="register-interest-button" v-on:click="registerInterest">Register your interest</button>
        </div>
      </div>

    </div>
</template>

<script>
import JQuery from 'jquery'

let $ = JQuery

export default {
  name: 'SignUp',
  data: () => ({
    email: '',
    message: 'Invalid Email',
    showWarning: false
  }),
  watch: {
    email: function () {
      this.showWarning = false
    }
  },
  methods: {
    validateEmail: (email) => {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    registerInterest: function () {
      console.log('I would like to register my interest pls')
      var URL = 'https://u7v9xytsb9.execute-api.us-east-1.amazonaws.com/01/contact'

      let email = $('#email-input').val()

      if (!this.validateEmail(email)) {
        console.log('invalid email')
        this.showWarning = true

        return
      }

      $('#send-button').hide()
      $('#register-interest-button').hide()
      $('#spinner').show()

      var data = {
        name: 'n/a',
        email: $('#email-input').val(),
        subject: 'Spinning House - Interest Registered - ' + email,
        origin: 'SH',
        message: $('#email-input').val() + ' would like to subscribe to Spinning House email'
      }

      console.log('this is payload, subscribe email', data)

      return

      $.ajax({
        type: 'POST',
        url: URL,
        dataType: 'json',
        crossDomain: 'true',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(data),

        success: function () {
          console.log('Successfull')

          $('#spinner').hide()
          $('#status-text').html('Thanks for registering your interest!')
        },
        error: function () {
          console.log('UnSuccessfull')

          $('#spinner').hide()
          $('#status-text').html('Ooops, something went wrong. Please try again later.')
        } })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  h2 {
    padding: 40px 0;
  }

  input {
    height: 22px;
    width: 340px;
    padding: 10px;
    border-radius: 20px;
    border: 0;
  }

  .section-container {
    text-align: center;
    max-width: 1000px;
    background-color: #1d1e21;
    height: 520px;
    margin: auto;
  }

  .section {
    display: inline-block;
    width: 500px;
    color: #fff;
    vertical-align: top;
    height: 520px;
  }

  .socail-container img {
    filter: invert(0);
  }

  .bg-img-section {
    background-image: url('https://s3-eu-west-1.amazonaws.com/all-about-ipswich/assets/images/homepage/Waterfront-hompage-AAI.jpg?mtime=20180913101540');
    position: relative;
    opacity: 0.65;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    filter: grayscale(100%);
  }

  @media only screen and (max-width: 1016px) {
  .bg-img-section {
      width: 100%;
    }
  }

  .invalid-warning {
    position: relative;
    height: 60px;
  }

  /* spinner */

  .lds-dual-ring {
    display: inline-block;
    width: 64px;
    height: 64px;
  }
  .lds-dual-ring:after {
    content: " ";
    display: block;
    width: 46px;
    height: 46px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media only screen and (max-width: 800px) {
    .section {
      width: 100%;
    }
  }

</style>
